export class Globals {
  static importUpload: boolean = false;
}
